import React, { Component } from "react";
import { Header } from "semantic-ui-react";
import api from "../../services/api";
import {
  BsChevronRight,
  BsChevronLeft,
  BsFillTagFill,
  BsTag,
} from "react-icons/bs";

import "./styles.css";

class Index extends Component {
  state = {
    products: [],
    productInfo: {},
    page: 1,
    viewport: this.props.viewport,
  };

  rad(x) {
    return (x * Math.PI) / 180;
  }

  getDistance(p1, p2) {
    var R = 6378137; // Earth’s mean radius in meter
    var dLat = this.rad(p2[0] - p1[0]);
    var dLong = this.rad(p2[1] - p1[1]);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.rad(p1[0])) *
        Math.cos(this.rad(p2[0])) *
        Math.sin(dLong / 2) *
        Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d; // returns the distance in meter
  }

  componentDidMount() {
    this.loadProduct();
  }

  loadProduct = async (page = 1) => {
    const response = await api.get(`/produto?page=${page}`);
    const { docs, ...productInfo } = response.data;
    this.setState({ products: docs, productInfo, page });
  };

  nextPage = () => {
    const { page, productInfo } = this.state;

    if (page === productInfo.pages) return;

    const pageNumber = page + 1;

    this.loadProduct(pageNumber);
  };

  prevPage = () => {
    if (this.state.page < 1) return;

    this.loadProduct(this.state.page - 1);
  };

  render() {
    const { products, page } = this.state;
    document.body.style.overflow = "hidden";
    products.map(
      (product) =>
        (product.distancia = this.getDistance(
          product.localizacao[1],
          this.props.viewport
        ))
    );

    return (
      <div
        style={{
          overflowY: "hidden",
          overflowX: "hidden",
        }}
      >
        <Header
          as="h2"
          textAlign="center"
          style={{
            maxWidth: "300px",
            padding: "15px 15px 0 15px",
            display: "flex",
            justifyContent: "center",
            marginBottom: "13px",

            // backgroundColor: "#0e7ba8",
            // borderRadius: "5px",
          }}
        >
          Produtos em falta na região
        </Header>

        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            className="product-list"
            style={{
              minWidth: "200px",
              maxWidth: "700px",
              padding: "1px 10px",
              margin: "1px auto 0",
            }}
          >
            {products.map((product) => {
              if (product.distancia < 8000) {
                return (
                  <div style={{ display: "flex" }}>
                    <BsFillTagFill size={25} style={{ margin: "5px" }} />
                    <article
                      key={product._id}
                      style={{
                        padding: "5px",
                        backgroundColor: "transparent",
                        border: "0",
                      }}
                    >
                      <Header
                        as="h5"
                        textAlign="left"
                        style={{
                          fontSize: "1.3em",
                          maxWidth: "150px",
                          margin: "0",
                        }}
                      >
                        <Header.Content> {product.nome}</Header.Content>
                      </Header>
                      <p style={{ color: "#242424", bold: "600" }}>
                        {product.descricao}
                      </p>
                    </article>
                  </div>
                );
              } else {
                return (
                  <div style={{ display: "flex" }}>
                    <BsTag
                      size={25}
                      style={{ margin: "5px", color: "#6b6b6b" }}
                    />
                    <article
                      key={product._id}
                      style={{
                        padding: "5px",
                        backgroundColor: "transparent",
                        border: "0",
                      }}
                    >
                      <Header
                        as="h5"
                        textAlign="left"
                        style={{
                          fontSize: "1.3em",
                          maxWidth: "150px",
                          margin: "0",
                          color: "#6b6b6b",
                        }}
                      >
                        <Header.Content> {product.nome}</Header.Content>
                      </Header>
                      <p style={{ color: "#6b6b6b", bold: "600" }}>
                        {product.descricao}
                      </p>
                    </article>
                  </div>
                );
              }
            })}

            <div className="actions">
              <button disabled={page === 1} onClick={this.prevPage}>
                <BsChevronLeft />
              </button>
              <button
                disabled={page === this.state.productInfo.pages}
                onClick={this.nextPage}
              >
                <BsChevronRight />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
